import { MaskedLines } from "./Reveal";

export const PageHero = ({ eyebrow, title, subtitle }) => (
  <section className="pt-36 pb-16 md:pt-44 md:pb-20 max-w-[1400px] mx-auto px-6 lg:px-10">
    <p className="label-eyebrow text-[#C8A98E] mb-6">{eyebrow}</p>
    <h1 className="font-heading text-5xl md:text-7xl font-light leading-[0.95] tracking-tight text-[#2A2118] max-w-4xl">
      <MaskedLines lines={Array.isArray(title) ? title : [title]} />
    </h1>
    {subtitle && (
      <p className="mt-8 text-lg font-light text-[#5c5245] max-w-2xl leading-relaxed">{subtitle}</p>
    )}
  </section>
);
